import { render } from "./HRA.vue?vue&type=template&id=0bc53680"
import script from "./HRA.vue?vue&type=script&lang=js"
export * from "./HRA.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__